import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image1 from "../assests/image1.png";
// import Image2 from "../assests/gouse.png";
function about() {
  return (
  <Container className='mt-5' >
    <Row id="about">
        <Col lg={6} md={6} sm={12} xs={12}>
        <h2 className='text-white mb-3' data-aos="fade-right"><span className='color'>01.&nbsp; &nbsp;</span>About Me</h2>
         <p className="color2 font2 mb-3" data-aos="fade-right">Dynamic Full Stack Engineer and Developer at IIIT Nuzvid, with a knack for crafting innovative websites.</p>
         <p className="color2 font2 mb-3" data-aos="fade-right" >Equipped with a robust skill set and a thirst for learning, I thrive on pushing the boundaries of web development. Passionate about technology and driven by creativity, I'm ready to make a mark in the world of software engineering.</p>
        <p className="color2 font2 mb-3" data-aos="fade-right">Here are a few technologies I’ve been working with recently:</p>
        <Row className="padd" data-aos="fade-right">
            <Col lg={6} md={6} sm={6} xs={6}> 
              <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}} alt="next-icon"></img>Javascript (ES7)</p>
             </Col>
   <Col lg={6} md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}} alt="next-icon"></img>React. js</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Node. js</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Mongo db</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Html5/Css</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Express</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Python</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Django</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>Rest Api</p>
   </Col>
   <Col lg={6}  md={6} sm={6} xs={6}>
   <p className='text-white font2 mb-3'>  <img src={Image1} width={40} style={{paddingRight:"15px"}}alt="next-icon"></img>My Sql</p>
   </Col>
        </Row>

        </Col>
        <Col>
{/* <img src={Image3} alt="my-pic"></img> */}
        </Col>
    </Row>
  </Container>    
  )
}

export default about
